import { ExplorePageLink } from '@components/Cards/ExporePageLink/ExplorePageLink';
import { LinksEnum } from '@specs/navigation';
import s from './navigationCards.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import cn from 'classnames';
import { Dictionary } from '@hooks/useTranslation';
const paths: navType[] = [{
  path: LinksEnum.EXPLORE_TOYS,
  title: 'toy.page.collection.stats.toys',
  cdnPath: 'toys-nav'
}, {
  path: LinksEnum.EXPLORE_COLLECTIONS,
  title: 'collections.page.title',
  cdnPath: 'collections_new'
}, {
  path: LinksEnum.EXPLORE_ARTISTS,
  title: 'artists.page.title',
  cdnPath: 'artists'
}];
type navType = {
  path: string;
  title: Dictionary;
  cdnPath: string;
};
export const NavigationCards = () => {
  return <div className={s.navigation} data-sentry-component="NavigationCards" data-sentry-source-file="NavigationCards.tsx">
            <div className={cn(s.navigation__container)}>
                <div className={s.navigation__box}>
                    <Swiper className={s.navigation__slider} slidesPerView={'auto'} spaceBetween={20} preventClicks data-sentry-element="Swiper" data-sentry-source-file="NavigationCards.tsx">
                        {paths.map(({
            path,
            title,
            cdnPath
          }, i) => <SwiperSlide className={s.navigation__slide} key={i}>
                                    <ExplorePageLink cdnPath={cdnPath} title={title} path={path} />
                                </SwiperSlide>)}
                    </Swiper>
                </div>
            </div>
        </div>;
};